module.exports = __webpack_public_path__ + "static/monty-python-with-origin.bba26241.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/monty-python-with-origin.svg
// module id = 449
// module chunks = 35783957827783 172322841747965